import React from "react";
import { apiGet } from "@redriver/cinnamon";
import { NonPropagatingTypeAhead } from "features/../../../shared/components/forms/NonPropagatingField";

export const ClientAuthSignsLookups = {
  GetAuthSigns: "getClientAuthSignsLookup",
};

const ActionTypes = {
  GetAuthSigns: "LOOKUPS/GET_CLIENT_AUTH_SIGNS",
};

export const ClientAuthSignTypeAhead = ({
  sheetId,
  field,
  label,
  readOnly,
}) => {
  const signatoriesLookupAction = ({ sheetId, search }) =>
    apiGet(ActionTypes.GetAuthSigns, "lookups/clients/authorised-signatories", {
      sheetId,
      queryTerm: search,
    });
  return (
    <NonPropagatingTypeAhead
      required
      readOnly={readOnly}
      searchSuggestions
      field={field}
      label={label}
      placeholder="Search Authorised Signatories..."
      lookupAction={signatoriesLookupAction}
      lookupParams={{
        sheetId: sheetId,
      }}
      lookupOptions={{
        cache: true,
        cacheLimit: 5,
        transform: (data) =>
          Array.isArray(data)
            ? data.map((x) => ({
                ...x,
                value: x.id,
                text: `${x.name} - ${x.position} - ${x.email}`,
              }))
            : [],
      }}
      className="client-auth-sign-dropdown"
      optionField="authorisedSignatory"
    />
  );
};
